module.exports = __webpack_public_path__ + "media/front/images/placeholder-05e4da230873948c1bf94eb5608e9588.png";